const th = {
  meta: { code: "th", label: "ไทย" },
  nav: {
    brand: "IQ Log",
    diagnostics: "การประเมิน",
    mypage: "หน้าของฉัน",
    login: "เข้าสู่ระบบ",
    register: "สมัครสมาชิก",
    logout: "ออกจากระบบ",
  },
  hero: {
    eyebrow: "แพลตฟอร์มประเมิน",
    title: "ค้นพบตัวตนของคุณผ่านการประเมิน",
    subtitle1: "ความคิด บุคลิก และความถนัด — มองเห็นได้ทั้งหมด",
    subtitle2: "เห็นจุดแข็งและจุดอ่อนภายใน 5 นาที",
    subtitle3: "ทุกการประเมินกลายเป็นข้อมูลของคุณ",
    cta_primary: "เริ่มการประเมิน",
    cta_secondary: "ดูแคตตาล็อก",
    disclaimer: "ข้อมูลอ้างอิง / ไม่ใช่ทางการแพทย์",
  },
  categories: {
    ability: "ความสามารถ",
    personality: "บุคลิก",
    mental: "จิตใจ",
    aptitude: "ความถนัด",
    traits: "คุณลักษณะ",
  },
  catalog: {
    title: "การประเมินทั้งหมด",
    subtitle: "17 ชุด / 5 หมวด",
    filter_all: "ทั้งหมด",
    duration: "นาที",
    difficulty: { easy: "ง่าย", medium: "ปานกลาง", hard: "ยาก" },
    question_count: "ข้อ",
    start: "เริ่ม",
  },
  quiz: {
    question: "คำถาม",
    of: "/",
    next: "ถัดไป",
    prev: "ย้อนกลับ",
    submit: "ดูผลลัพธ์",
    progress: "ความคืบหน้า",
    exit: "ออก",
    required: "กรุณาเลือกตัวเลือก",
    submitting: "กำลังให้คะแนน…",
  },
  result: {
    overall: "คะแนนรวม",
    type_label: "ประเภท",
    share_link: "แชร์ผลลัพธ์ด้วยลิงก์",
    back_to_catalog: "ทำการประเมินอื่น",
    view_mypage: "ดูประวัติในหน้าของฉัน",
    premium_title: "ปลดล็อกการวิเคราะห์เชิงลึก",
    premium_subtitle: "ด้วยพรีเมียม คุณจะเห็นทุกอย่างด้านล่าง:",
    feature_breakdown: "การแยกคะแนนเชิงลึก",
    feature_cause: "การวิเคราะห์สาเหตุ",
    feature_plan: "แผนการพัฒนา",
    feature_pdf: "รายงาน PDF (A4)",
    price: "¥980",
    price_note: "(ชำระเงินปลอดภัยผ่าน Stripe)",
    price_free: "ฟรี",
    price_free_note: "(จำกัดเวลา · ฟรี 100%)",
    unlock_button: "ชำระด้วย Stripe",
    unlock_button_free: "ปลดล็อกฟรี",
    unlock_requires_auth: "กรุณาเข้าสู่ระบบเพื่อปลดล็อก",
    unlock_save_first: "บันทึกผลลัพธ์ด้วยบัญชีก่อน",
    unlocking: "กำลังนำไปยัง Stripe…",
    free_only_notice: "เวอร์ชันฟรีแสดงเฉพาะคะแนนรวมและประเภท",
    compliance_note:
      "การประเมินนี้เป็นข้อมูลอ้างอิงเท่านั้นและไม่ใช่การวินิจฉัยทางการแพทย์ เราหลีกเลี่ยงคำพูดที่ตัดสินหรือสร้างความวิตก",
  },
  premium: {
    title: "รายงานการวิเคราะห์เชิงลึก",
    summary: "ภาพรวม",
    strengths: "จุดแข็ง",
    weaknesses: "พื้นที่พัฒนา",
    improvements: "แผนการพัฒนา",
    dimensions: "คะแนนตามมิติ",
    download_pdf: "ดาวน์โหลด PDF",
    pdf_soon: "ส่งออก PDF (เร็ว ๆ นี้)",
  },
  mypage: {
    title: "หน้าของฉัน",
    subtitle: "ประวัติ แนวโน้มคะแนน และตราของคุณ",
    total: "จำนวนการประเมิน",
    average: "คะแนนเฉลี่ย",
    premium_count: "ปลดล็อกแล้ว",
    categories_covered: "หมวดที่ครอบคลุม",
    trend_title: "แนวโน้มคะแนน",
    history_title: "ประวัติ",
    badges_title: "ตรา",
    unlock_3_title: "ปลดล็อกการวิเคราะห์รวม",
    unlock_3_desc: "ทำอีก {n} ครั้งเพื่อปลดล็อกการวิเคราะห์รวม",
    unlocked: "ปลดล็อกการวิเคราะห์รวมแล้ว",
    no_history: "ยังไม่มีการประเมิน — เริ่มการประเมินแรกเลย",
  },
  auth: {
    login_title: "เข้าสู่ระบบ",
    register_title: "สร้างบัญชี",
    email: "อีเมล",
    password: "รหัสผ่าน (อย่างน้อย 6 ตัว)",
    name: "ชื่อแสดง (ไม่บังคับ)",
    login_btn: "เข้าสู่ระบบ",
    register_btn: "สมัคร",
    go_register: "ยังไม่มีบัญชี? สมัคร",
    go_login: "มีบัญชีแล้ว? เข้าสู่ระบบ",
    anon_note: "การประเมินฟรีและไม่ระบุชื่อ ต้องใช้บัญชีเฉพาะเมื่อบันทึกผลและปลดล็อกพรีเมียม",
    success_register: "สร้างบัญชีแล้ว",
    success_login: "เข้าสู่ระบบแล้ว",
    consent_section: "การยินยอม",
    consent_required: "กรุณายอมรับรายการที่จำเป็น",
    accept_terms_pre: "ฉันยอมรับ",
    terms_link: "ข้อกำหนดการใช้งาน",
    accept_terms_post: "",
    accept_privacy_pre: "ฉันได้อ่าน",
    privacy_link: "นโยบายความเป็นส่วนตัว",
    accept_privacy_post: "และยินยอมให้ประมวลผลข้อมูลส่วนบุคคล",
    accept_age: "ฉันอายุ 16 ปีขึ้นไป (หรือได้รับความยินยอมจากผู้ปกครอง)",
    accept_marketing: "ส่งอีเมลแจ้งการประเมินใหม่และโปรโมชัน",
    optional: "ไม่บังคับ",
  },
  landing: {
    status_online: "ระบบออนไลน์",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 ชุด",
    status_langs: "14 ภาษา",
    status_ai: "AI · เปิดใช้งาน",
    title_line1: "ค้นพบตัวตน",
    title_line2: "ใน 5 นาที",
    trust_diagnostics: "การประเมิน",
    trust_languages: "ภาษา",
    trust_per_test: "ต่อชุด",
    hud_readout: "การอ่านหลัก",
    hud_score_unit: "/100 รวม",
    hud_band: "ระดับ · GOLD",
    hud_dimensions: "มิติ",
    hud_dimensions_status: "3 / 3 ใช้งาน",
    hud_syslog: "บันทึกระบบ",
    cat_eyebrow: "// หมวด",
    cat_title_pre: "5 หมวด · ",
    cat_title_highlight: "17 ประเมิน",
    view_all: "ดูทั้งหมด",
    proto_eyebrow: "// ขั้นตอน",
    proto_title_pre: "ปลดล็อกตัวตน ",
    proto_title_highlight: "ใน 3 ขั้น",
    step1_title: "เลือกแบบทดสอบ",
    step1_body: "เลือกจาก 17 ชุด เริ่มแบบไม่ระบุชื่อได้",
    step2_title: "ตอบใน 5 นาที",
    step2_body: "แถบความคืบหน้าและตราเสริมแรงจูงใจ",
    step3_title: "ปลดล็อกด้วย AI",
    step3_body: "คะแนนละเอียด แผน และ PDF",
    final_eyebrow: "// พร้อมหรือยัง?",
    final_title_pre: "ตัวตนของคุณ ",
    final_title_highlight: "ใน 5 นาที",
    final_subtitle: "เห็นจุดแข็งและจุดอ่อนภายใน 5 นาที",
    final_button: "เริ่มประเมินทันที",
  },
  footer: {
    tagline: "แพลตฟอร์มประเมินความคิด บุคลิก และความถนัด",
    rights: "สงวนลิขสิทธิ์",
    legal: "กฎหมาย",
    privacy: "ความเป็นส่วนตัว",
    terms: "ข้อกำหนด",
    about_label: "เกี่ยวกับ / บริษัท",
    compliance_label: "การปฏิบัติตามกฎระหว่างประเทศ",
    tokushoho_label: "พ.ร.บ.การพาณิชย์ญี่ปุ่น",
    data_protection_label: "การคุ้มครองข้อมูล (สากล)",
    data_request_label: "ลบข้อมูล / ยกเลิกการตลาด",
    disclaimer_label: "ข้อจำกัดความรับผิด",
    disclaimer_full: "บริการนี้เป็นข้อมูลอ้างอิงเท่านั้นและไม่ใช่การวินิจฉัยทางการแพทย์ เราไม่ใช้ภาษาที่ตัดสินหรือสร้างความวิตก",
  },
  badges: {
    "first-diagnosis": "การประเมินแรก",
    "three-diagnostics": "3 ครั้ง",
    "five-diagnostics": "5 ครั้ง",
    "ten-diagnostics": "10 ครั้ง",
    "high-performer": "ผู้มีผลงานสูง",
    "premium-user": "ผู้ใช้พรีเมียม",
  },
  lang_selector: "ภาษา",
  payment: {
    processing_title: "กำลังตรวจสอบการชำระเงิน…",
    processing_subtitle: "กลับจาก Stripe — กำลังสร้างการวิเคราะห์เชิงลึก (ภายใน 20 วินาที)",
    success: "ยืนยันการชำระเงินแล้ว — ปลดล็อกพรีเมียมแล้ว",
    expired: "เซสชันการชำระเงินหมดอายุ กรุณาลองใหม่",
    error: "ไม่สามารถยืนยันการชำระเงินได้ โปรดติดต่อฝ่ายสนับสนุน",
  },
};
export default th;
